import { HubConnectionBuilder, LogLevel } from "@microsoft/signalr"

import { getEnv } from "@/lib/utils/env"

import { createMockHub } from "./signalr-mock"

/**
 * SignalR hub factory.
 *
 * ADR #011: WebSocket MSW'nin dışında + gerçek hub CORS ile engelleniyor.
 * `HubConnectionLike` interface ile mock/real branch edilir (`VITE_MOCK_API`).
 *
 * Bileşenler doğrudan @microsoft/signalr import etmez; bu modülün interface'ine bağlanır.
 */

export type HubName = "deviceNotificationHub"

export type HubState = "Disconnected" | "Connecting" | "Connected"

export interface HubConnectionLike {
  readonly state: HubState
  start(): Promise<void>
  stop(): Promise<void>
  on(event: string, handler: (payload: unknown) => void): void
  off(event: string, handler: (payload: unknown) => void): void
}

export function createHubConnection(
  hubName: HubName,
  getToken: () => string | null,
): HubConnectionLike {
  if (getEnv().VITE_MOCK_API) {
    return createMockHub(hubName)
  }
  const env = getEnv()
  const conn = new HubConnectionBuilder()
    .withUrl(`${env.VITE_SIGNALR_URL}/${hubName}`, {
      accessTokenFactory: () => getToken() ?? "",
    })
    .withAutomaticReconnect([0, 2_000, 5_000, 10_000, 30_000])
    .configureLogging(LogLevel.Warning)
    .build()
  return {
    get state() {
      return conn.state as HubState
    },
    start: () => conn.start(),
    stop: () => conn.stop(),
    on: (event, handler) => conn.on(event, handler as (...args: unknown[]) => void),
    off: (event, handler) => conn.off(event, handler as (...args: unknown[]) => void),
  }
}
